import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

export default function ClassListSearchSort({
  searchText,
  searchPlaceholder,
  onSearchChange,
  onSearchClear,
  onSearchSubmit,
  timeOfDayOptions = [],
  selectedTimeOfDay = "",
  onTimeOfDayChange,
}) {
  return (
    <div className="flex flex-column xl:flex-row gap-2 w-full">
      <div className="relative w-full input-search-container flex flex-1 min-w-0">
        {searchText && (
          <i
            className="pi pi-times z-5 flex icon w-max absolute times-icon custom-icon cursor-pointer r-0625"
            onClick={(e) => {
              e.stopPropagation();
              onSearchClear();
            }}
          />
        )}
        <InputText
          className="keduall-form input-default-small keduall-typography text-16-semibold-600 text-default-txt w-full pr-5"
          value={searchText}
          placeholder={searchPlaceholder}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearchSubmit();
            }
          }}
        />
      </div>
      <div className="flex flex-row gap-2 flex-shrink-0 lg:flex-nowrap flex-wrap">
        {timeOfDayOptions.map((opt) => (
          <Button
            key={opt.value || "all"}
            label={opt.label}
            className={
              (selectedTimeOfDay ?? "") === opt.value
                ? "keduall-buttons flex button-filled-default-normal-primary flex-shrink-0"
                : "keduall-buttons flex button-outlined-default-normal-secondary flex-shrink-0"
            }
            onClick={() => onTimeOfDayChange?.(opt.value)}
          />
        ))}
      </div>
    </div>
  );
}
